import { useState } from 'react'

export function useEmployeeTable() {
  const [employees, setEmployees] = useState([])
  const [editingIndex, setEditingIndex] = useState(null)

  const addOrEditEmployee = values => {
    if (editingIndex !== null) {
      const updated = [...employees]
      updated[editingIndex] = { ...values }
      setEmployees(updated)
      setEditingIndex(null)
    } else {
      setEmployees([...employees, { ...values }])
    }
  }

  const selectForEdit = idx => setEditingIndex(idx)

  const deleteEmployee = idx => {
    setEmployees(employees.filter((_, i) => i !== idx))
    if (editingIndex === idx) setEditingIndex(null)
  }

  const initialValues = editingIndex !== null ? employees[editingIndex] : {}

  const clearAllEmployees = () => {
    setEmployees([])
    setEditingIndex(null)
  }

  return {
    employees,
    addOrEditEmployee,
    selectForEdit,
    deleteEmployee,
    editingIndex,
    initialValues,
    setEditingIndex,
    clearAllEmployees
  }
}
